import common from "../../common";
import MiniSignal from "mini-signals";
import ControlMethod from "./ControlMethod";

export default class ControlMethodAITutorial extends ControlMethod
{
    constructor(fighter)
    {
        super(fighter);

        this.fireInterval = 0.5;
        this.accumulatedInterval = 0;

        this.aggression = 0.5;

        this.target = null;

        this.enemy = null;

        this.targetMarker = common.display.circle({radius:5, fillColour:0x000000, visible:false, parent:this.gameScene});

        this.init();
    }

    init()
    {
        if(this.fighter.characterData.enemyData)
        {
            var fr = common.config.settings.gamePhysics.ai.fireRate;
            if(fr)
            {
                this.fireInterval = 1 - (fr[0] + (this.fighter.characterData.enemyData.fireRate * (fr[1] - fr[0])));
            }
            this.aggression = this.fighter.characterData.enemyData.aggression;
        }
        this.randomRoute();
    }

    destroy()
    { 
        super.destroy();
    }

    update()
    {
        this.accumulatedInterval += P3.Ticker.dt;

        if(this.accumulatedInterval >= this.fireInterval)
        {
            this.accumulatedInterval = 0;
            for(var i in this.fighter.gameScene.fighters)
            {
                var f = this.fighter.gameScene.fighters[i];
                if(f.id !== this.fighter.id)
                {
                    this.enemy = f;
                    if((this.fighter.y > f.y + f.bounds.y && this.fighter.y < f.y + f.bounds.y + f.bounds.height) ||
                       (this.fighter.y + this.fighter.bounds.y > f.y + f.bounds.y && this.fighter.y + this.fighter.bounds.y < f.y + f.bounds.y + f.bounds.height))
                    {
                        this.signals.fireProjectile.dispatch();
                    }
                }
            }
        }

        if(this.target && this.target.point)
        {
            var padding = this.fighter.y - (this.fighter.y + this.fighter.bounds.y + this.fighter.bounds.height) + 5;

            if(this.isPointInsideBounds(this.target.point.x, this.target.point.y-padding, this.fighter.x, this.fighter.y, this.fighter.bounds) )
            {
                this.randomRoute();

                this.targetMarker.x = this.target.point.x;
                this.targetMarker.y = this.target.point.y;
            }

            var angle = Math.atan2(this.target.point.y - this.fighter.y, this.target.point.x - this.fighter.x);
            if(angle < 0) angle = (2*Math.PI) + angle;

            this.movement.y = Math.sin(angle);
            this.movement.x = Math.cos(angle);
        }
    }

    randomRoute()
    {
        var rounds = 1;
        var division = 2;
        var field = this.fighter.field;

        var x, y, w, h;

        var points = [];

        for(var r = 0; r < rounds; r++)
        {
            for(var col = 0; col < division; col++)
            {
                for(var row = 0; row < division; row++)
                {
                    x = field.x + ((field.width / division) * col);
                    y = field.y + ((field.height / division) * row);
                    points.push({
                        x: x + ((field.width / division) * Math.random()),
                        y: y + ((field.height / division) * Math.random())
                    });
                }
            }
        }

        this.target = {point:points[Math.floor(points.length * Math.random())]};

        var b = this.fighter.bounds;
        var f = this.fighter.field;
        var p = this.target.point;

        if(p.x + b.x + b.width > f.x + f.width)
        {
            p.x = f.x + f.width - b.x - b.width;
        }
        if(p.x + b.x < f.x)
        {
            p.x = f.x - b.x;
        }
        if(p.y + b.y + b.height > f.y + f.height)
        {
            p.y = f.y + f.height - b.y - b.height;
        }
        if(p.y + b.y < f.y)
        {
            p.y = f.y - b.y;
        }
    }

    targetRoute()
    {
        this.randomRoute();
        for(var i in this.fighter.gameScene.fighters)
        {
            var f = this.fighter.gameScene.fighters[i];
            if(f.id !== this.fighter.id)
            {
                this.target.point.y = f.y;
            }
        }
    }
    
    powerupRoute(x, y, powerup)
    {
        var field = this.fighter.field;

        this.target.point.x = x + (powerup.hitBox.x * field.direction);
        this.target.point.y = y;

        if(this.target.point.x > field.x + field.width)
        {
            this.target.point.x = field.x + field.width;
        }
        if(this.target.point.x < field.x)
        {
            this.target.point.x = field.x;
        }
        if(this.target.point.y > field.y + field.height)
        {
            this.target.point.y = field.y + field.height;
        }
        if(this.target.point.y < field.y)
        {
            this.target.point.y = field.y;
        }
    }
}